import { render, staticRenderFns } from "./trashDeleteBinGrey.vue?vue&type=template&id=c6c8d968&"
import script from "./trashDeleteBinGrey.vue?vue&type=script&lang=js&"
export * from "./trashDeleteBinGrey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports